export interface StepNamedElements {
  stepType: string;
  element: string;
}

export const stepNamedElements: StepNamedElements[] = [
  {
    stepType: 'color_collapsible',
    element: 'fg-color-stacked',
  },
  {
    stepType: 'version_collapsible',
    element: 'fg-version-stacked',
  },
  {
    stepType: 'print_option_collapsible',
    element: 'fg-print-option-stacked',
  },
  {
    stepType: 'quantity_collapsible',
    element: 'fg-quantity-stacked',
  },
  {
    stepType: 'quantity_per_color_collapsible',
    element: 'fg-quantity-stacked',
  },
  {
    stepType: 'quantity_per_size_collapsible',
    element: 'fg-quantity-stacked',
  },
  {
    stepType: 'quantity_per_size_per_color_collapsible',
    element: 'fg-quantity-stacked',
  },
];
